import "./reference.css";
import grade3 from "./json/grade3.json";
import grade4 from "./json/grade4.json";
import grade5 from "./json/grade5.json";
import grade6 from "./json/grade6.json";
import { MathJax, MathJaxContext } from "better-react-mathjax";
import { IAdaptivePracticeContext } from "../../interface/interface";
import { useContext } from "react";
import { AdaptivePracticeContext } from "../../../../context/context";
import { FAClose } from "../../../../components/atoms/fontawesomeIcon/Fontawesome";
import { IReducer, IUserReducer } from "../../../../interface/interface";
import { useSelector } from "react-redux";

export function ReferenceMaterialForAssessment() {
  const APContext: IAdaptivePracticeContext = useContext(
    AdaptivePracticeContext
  );

  const userReducer: IUserReducer = useSelector((state: IReducer) => state.userReducer);
  const currentUser = userReducer.currentUser;

  const referenceDataMap: Record<string, any> = {
    grade3,
    grade4,
    grade5,
    grade6,
  };

  const referenceJson = referenceDataMap[`grade${currentUser.grade}`];
  if (!referenceJson) return null;

  const mathJaxConfig = {
    tex: {
      inlineMath: [["$", "$"]],
      displayMath: [["$$", "$$"]],
    },
  };

  return (
    <MathJaxContext config={mathJaxConfig}>
      <div className="reference-overlay">
        <div className="reference-card">
          {/* Header */}
          <div className="reference-header">
            <h2 className="reference-title">{referenceJson.main_heading}</h2>

            <button
              className="reference-close-btn"
              onClick={() => APContext.options?.showReferenceScreen!(false)}
              aria-label="Close reference"
            >
              <FAClose color="#fff"/>
            </button>
          </div>

          {/* Body */}
          <div className="reference-body">
            {referenceJson.sections.map(
              (section: any, sectionIndex: number) => {
                const hasSubTitles =
                  Array.isArray(section.subTitle) &&
                  section.subTitle.length > 0;
                const isTwoColumn = hasSubTitles && section.subTitle.length > 1;

                return (
                  <div key={sectionIndex} className="reference-section">
                    <h3 className="section-title">{section.title}</h3>

                    <div
                      className={`section-content ${
                        isTwoColumn ? "two-column" : "one-column"
                      }`}
                    >
                      {hasSubTitles ? (
                        // Render subTitle formulas
                        section.subTitle.map((sub: any, subIndex: number) => (
                          <div key={subIndex} className="system-column">
                            <h4 className="system-title">{sub.name}</h4>
                            <ul className="system-list">
                              {sub.formulae.map(
                                (item: any, itemIndex: number) => (
                                  <li key={itemIndex} className="math-left">
                                    <MathJax dynamic>{item.formula}</MathJax>
                                  </li>
                                )
                              )}
                            </ul>
                          </div>
                        ))
                      ) : (
                        // Render formulas directly
                        <div className="system-column">
                          <ul className="system-list">
                            {section.formulae.map(
                              (item: any, itemIndex: number) => (
                                <li key={itemIndex} className="math-left">
                                  <MathJax dynamic>{item.formula}</MathJax>
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                );
              }
            )}
          </div>
        </div>
      </div>
    </MathJaxContext>
  );
}
